module.exports = __webpack_public_path__ + "static/media/MDCLogo-Blue.296b3b67.png";